export const buildSingleGoogleMapsURL = (searchCity, searchState, load) => {
  const origin = `${searchCity}, ${searchState}`;
  const waypoints = [`${load.origin_city}, ${load.origin_state}`];
  const destination = `${load.destination_city}, ${load.destination_state}`;
  return `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}&waypoints=${waypoints}&travelmode=driving`;
};

export const buildSavedSingleGoogleMapsURL = (load) => {
  const origin = `${load.origin_city}, ${load.origin_state}`;
  const destination = `${load.destination_city}, ${load.destination_state}`;
  return `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}&travelmode=driving`;
};

export const buildPairGoogleMapsURL = (
  searchOriginCity,
  searchOriginState,
  outboundOriginCity,
  outboundOriginState,
  outboundDestCity,
  outboundDestState,
  returnOriginCity,
  returnOriginState,
  returnDestCity,
  returnDestState,
) => {
  const origin = `${searchOriginCity}, ${searchOriginState}`;
  const destination = `${searchOriginCity}, ${searchOriginState}`;

  const waypoints = [
    `${outboundOriginCity}, ${outboundOriginState}`,
    `${outboundDestCity}, ${outboundDestState}`,
    `${returnOriginCity}, ${returnOriginState}`,
    `${returnDestCity}, ${returnDestState}`,
  ]
    .map(encodeURIComponent)
    .join("|");

  return `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}&waypoints=${waypoints}&travelmode=driving`;
};

export const buildSavedPairGoogleMapsURL = (load1, load2) => {
  const origin = `${load1.origin_city}, ${load1.origin_state}`;
  const destination = `${load2.destination_city}, ${load2.destination_state}`;

  const waypoints = [
    `${load1.destination_city}, ${load1.destination_state}`,
    `${load2.origin_city}, ${load2.origin_state}`,
  ]
    .map(encodeURIComponent)
    .join("|");

  return `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}&waypoints=${waypoints}&travelmode=driving`;
};
